import { FC, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Link } from 'react-router-dom';
import { Collapse, IconButton, TableCell, TableRow } from 'components/common';
import { IProductRowProps } from './types';
import { EditIcon } from 'components/common/Icons';
import { rowDataFormatter } from './rowDataFormatter';
import { productsEditingAccessUsers, tableColumnsNames } from '../types';
import { getPageURL, PageURL } from 'router/pageURL';
import { AccessWrapper } from 'components/AccessWrapper';

export const ProductRow: FC<IProductRowProps> = ({ sx, index, ...rowData }) => {
  const [open, setOpen] = useState(false);
  const opacity = rowData.isActive ? 1 : 0.5;
  const { headersCells, bodyCells } = rowDataFormatter(rowData, index);

  return (
    <>
      <TableRow
        data-testid={'productRow'}
        sx={{ '& > *': { borderBottom: open ? undefined : 'unset' }, opacity, ...sx }}
      >
        <TableCell>
          <IconButton data-testid={'expand-button'} aria-label='expand row' size='small' onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {headersCells.map(({ cell }) => cell)}
        <AccessWrapper accessGroups={productsEditingAccessUsers}>
          <TableCell>
            <Link to={getPageURL(PageURL.PRODUCTS_EDIT, { id: rowData.id })} className={`text-neutral-400`}>
              <EditIcon />
            </Link>
          </TableCell>
        </AccessWrapper>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={tableColumnsNames.length + 2}>
          <Collapse in={open} timeout='auto'>
            <div className={'grid grid-cols-4 grid-rows-2 gap-x-5 gap-y-2 p-2'}>
              {bodyCells.map(({ cell }) => cell)}
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
